import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import ModifierQuantity from './modifier-quantity';

const { classNames } = Mobi2Go.helpers;

export default forwardRefWithTranslation('product-editor')(
    class Modifier extends React.Component {
        static propTypes = {
            onClick: PropTypes.func.isRequired,
            onQuantityChange: PropTypes.func.isRequired,
            modifier: PropTypes.object.isRequired,
            t: PropTypes.func.isRequired,
        };

        onClick = () => {
            if (
                this.props.modifier.type !== 'boolean' &&
                this.props.modifier.type !== 'fractional'
            ) {
                return;
            }
            this.props.onClick(this.props.modifier);
        };

        onQuantityChange = e => {
            const value = +e.target.value;
            this.setQuantity(value);
        };

        setQuantity = quantity => {
            if (_.isNaN(quantity) || quantity < 0) {
                quantity = 0;
            }
            if (quantity > 2500) {
                quantity = 2500;
            }
            this.props.onQuantityChange(this.props.modifier, quantity);
        };

        render() {
            const { t, modifier } = this.props;
            if (modifier.visible === false) {
                return null;
            }
            const class_name = classNames(
                'm2g-product-editor-modifier',
                'm2g-touchable',
                { 'm2g-product-editor-modifier--default': modifier.is_default }
            );
            return (
                <div
                    className={class_name}
                    data-modifier={modifier.id}
                    data-modifier-name={modifier.backend_name}
                    data-tags={modifier.tags.join(' ')}
                    data-selection-state={modifier.selection_state}
                    data-type={modifier.type}
                    data-is-default={modifier.is_default ? true : null}
                    data-checked={modifier.selection_state !== 'off'}
                    data-out-of-stock={modifier.out_of_stock}
                    tabIndex="0"
                    role="button"
                    onClick={this.onClick}
                    onKeyDown={this.onKeyDown}
                    style={
                        modifier.out_of_stock ? { pointerEvents: 'none' } : {}
                    }
                >
                    {modifier.type == 'quantity' ? (
                        <>
                            <div className="m2g-product-editor-modifier-contents">
                                {_.includes(
                                    modifier.tags,
                                    'text-input-quantity'
                                ) ? (
                                    <input
                                        type="tel"
                                        className="m2g-product-editor-modifier-quantity-text m2g-input"
                                        value={modifier.quantity}
                                        onChange={this.onQuantityChange}
                                        data-modifier={modifier.id}
                                    />
                                ) : _.includes(
                                      modifier.tags,
                                      'list-quantity'
                                  ) ? (
                                    <div
                                        className="m2g-product-editor-modifier-quantity m2g-input-container"
                                        data-icon-after="select"
                                    >
                                        <select
                                            className="m2g-product-editor-modifier-quantity-select m2g-select"
                                            title={t('quantity')}
                                            data-modifier={modifier.id}
                                            value={modifier.quantity}
                                            onChange={this.onQuantityChange}
                                        >
                                            {_.map(
                                                _.range(
                                                    0,
                                                    modifier.quantity_limit + 1
                                                ),
                                                i => (
                                                    <option value={i} key={i}>
                                                        {i}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                ) : (
                                    <ModifierQuantity
                                        quantity={modifier.quantity}
                                        onChange={this.setQuantity}
                                        canIncrease={
                                            modifier.can_quantity_be_increased
                                        }
                                    />
                                )}

                                <div className="m2g-product-editor-modifier-name">
                                    {modifier.name}
                                </div>

                                {modifier.out_of_stock && (
                                    <div
                                        data-modifier-price
                                        className="m2g-product-editor-modifier-out-of-stock-label m2g-text--small m2g-text--offset"
                                    >
                                        {t('sold_out')}
                                    </div>
                                )}

                                {!modifier.out_of_stock && (
                                    <div
                                        data-modifier-price
                                        className="m2g-product-editor-modifier-price"
                                    >
                                        {t('common:price', {
                                            price: modifier.price,
                                        })}
                                    </div>
                                )}
                            </div>
                            <div className="m2g-product-editor-modifier-description">
                                {modifier.description}
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="m2g-product-editor-modifier-contents">
                                <div className="m2g-product-editor-modifier-checkbox m2g-icon m2g-icon--tick m2g-icon--checkbox" />
                                <div className="m2g-product-editor-modifier-name">
                                    {modifier.name}
                                </div>

                                {modifier.out_of_stock && (
                                    <div
                                        data-modifier-price
                                        className="m2g-product-editor-modifier-out-of-stock-label m2g-text--small m2g-text--offset"
                                    >
                                        {t('sold_out')}
                                    </div>
                                )}

                                {!modifier.out_of_stock && (
                                    <div
                                        data-modifier-price
                                        className="m2g-product-editor-modifier-price"
                                    >
                                        {t('common:price', {
                                            price: modifier.price,
                                        })}
                                    </div>
                                )}
                            </div>
                            <div className="m2g-product-editor-modifier-description">
                                {modifier.description}
                            </div>
                        </>
                    )}
                </div>
            );
        }
    }
);
